
import { Vue } from "vue-class-component";

export default class StiDest extends Vue {}
